module.exports = __webpack_public_path__ + "img/students1_new.8f5c4ccb.png";